import { Injectable, inject } from '@angular/core';
import { SessionStateService } from '@abp/ng.core';
import { ImpersonationService } from '@volo/abp.commercial.ng.ui/config';

@Injectable()
export class SitePlantImpersonationService extends ImpersonationService {
	private readonly sessionState = inject(SessionStateService);

	override impersonate(params: {
		tenantId?: string;
		userId?: string;
		tenantUserName?: string;
	}) {
		const isBackToImpersonator = !params?.tenantId && !params?.userId && !params?.tenantUserName;

		if (isBackToImpersonator) {
			this.sessionState.setTenant(null);
		}

		return super.impersonate(params);
	}
}
